import React  from 'react';
import { PayloadStates } from '@lore/utils';
import TextField from '../../projects/_fields/TextField';
import useMissingFields from '../useMissingFields';

export default function MissingFields(props) {
  const { offer } = props;

  const { missingFields } = useMissingFields(offer);

  if (missingFields.state === PayloadStates.FETCHING) {
    return (
      <TextField label="Missing Fields">
        ...
      </TextField>
    );
  }

  return (
    <TextField label="Missing Fields">
      {missingFields.data.map(function(field) {
        return field.label;
      }).join(', ')}
    </TextField>
  );
}
